import { Trans, useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { ChartColumnIcon } from "lucide-react";
import { useId } from "react";

import { useCurrentUser } from "@/features/auth";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/ui/sidebar";

// Группа «Для команды» бокового меню с пунктом «Дашборд» — только для `is_staff`
// (design/prototype/Sidebar.dc.html, `staff`). Остальным группы нет.
export const DashboardNavItem = () => {
  const { t } = useLingui();
  const labelId = useId();
  const { data: user } = useCurrentUser();
  if (user?.is_staff !== true) {
    return null;
  }
  return (
    <SidebarGroup aria-labelledby={labelId}>
      <SidebarGroupLabel id={labelId}>
        <Trans>For the team</Trans>
      </SidebarGroupLabel>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton asChild tooltip={t`Dashboard (team only)`}>
            <Link to="/dashboard">
              <ChartColumnIcon aria-hidden="true" />
              <span>
                <Trans>Dashboard</Trans>
              </span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
};
